import { render } from "./PerformanceChart.vue?vue&type=template&id=3d3a263c&ts=true"
import script from "./PerformanceChart.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__